<template>
  <div class="wg-col wg-xs-12 wg-md-4" style="padding:2%;">
    <div
      style="font-size:24px;"
      class="com-anm22-app-text-m"
    >{{$anm22.strLang(lang, "Export", "Esporta")}}</div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div>{{
      $anm22.strLang(lang, 'Export the CSV file of your company contacts list.', 'Esporta la lista contatti della tua azienda in formato CSV.')
      }}</div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Export', 'Esporta')"
        @click="exportContacts"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      windowWidth: state => state.windowWidth,
      workSelected: state => state.workSelected,
    })
  },
  methods: {
    exportContacts() {
      window.open(process.env.VUE_APP_BACK_DOMAIN + "/app/contacts/spa/controller/contacts/export-csv/?work=" + this.workSelected);
    },
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
</style>
